
const LIVE_URL = "https://api.erp.nsplprojects.com";
// const LOCAL_URL = "http://127.0.0.1:8000";
// export  const MAIN_URL = LIVE_URL

// const LIVE_URL = "https://api.erp.nsplprojects.com";
const LOCAL_URL = "http://127.0.0.1:8000";
export  const MAIN_URL = LIVE_URL


